import Model, { attr, hasMany, type AsyncHasMany } from '@ember-data/model';
import type ConnectVisitorContactModel from 'garaje/models/connect-visitor-contact';
import type TenantRoleModel from 'garaje/models/tenant-role';

export default class ConnectEmployeeModel extends Model {
  @attr('string') declare name: string;
  @attr('string') declare profilePictureUrl: string;

  @hasMany('tenant-role', { async: true, inverse: null }) declare tenantRoles: AsyncHasMany<TenantRoleModel>;
  @hasMany('connect-visitor-contact', { async: true, inverse: null })
  declare connectVisitorContacts: AsyncHasMany<ConnectVisitorContactModel>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'connect-employee': ConnectEmployeeModel;
  }
}
